import { BaseSyntheticEvent, Dispatch, useEffect, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress } from "@mui/material";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { object, ref } from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { PasswordValidateion } from "../../common/Validation";
import { UploadFile } from "../../common/Util";
import { ResponseParamBase } from "../../common/Types";
import { ApiUrl, RouterUrl } from "../../common/Params";
import { ResultMessage, CompleteParam } from "../pages/ResultMessage";
import configcss from "../../css/config.module.css";
import logincss from "../../css/login.module.css";
import dialogcss from "../../css/dialog.module.css";

type PasswordDialog = {
    isOpen: boolean,
    setIsOpen: Dispatch<React.SetStateAction<boolean>>,
    onClose: () => void,
    onSuccess: (param: CompleteParam) => void,
}

type IFormInputs = {
    currentPassword: string,
    newPassword: string,
    confirmationPassword: string,
}

type ResponseParam = ResponseParamBase & {

}

export const PasswordDialog = (prop: PasswordDialog) => {

    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [resultMessage, setResultMessage] = useState<string>("");
    const [resultFlg, setResultFlg] = useState<boolean>(false);

    const wait = async (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    const schema = object({
        currentPassword: PasswordValidateion,
        newPassword: PasswordValidateion,
        confirmationPassword: PasswordValidateion.oneOf([ref("newPassword")], "新規パスワードと確認用のパスワードが異なっています。"),
    }).required()

    const {control, handleSubmit, watch, register, formState: { errors, isValid }, setValue, reset} = useForm<IFormInputs>({
        mode: "onSubmit",
        defaultValues: {
            currentPassword: "",
            newPassword: "",
            confirmationPassword: "",
        },
        resolver: yupResolver(schema),
        reValidateMode: "onSubmit",
    });

    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs, event?: BaseSyntheticEvent) => {
        setResultMessage((value) => {return ""});
        await UploadFile<ResponseParam>(
            ApiUrl.ChangeUserPassword,
            data,
            setIsLoading,
        ).then((response) => {
            if(response.data.resultFlg){
                const param: CompleteParam = {message: response.data.message}
                //prop.setIsOpen((value) => { return false });
                setResultMessage((value) => { return response.data.message });
               setResultFlg((value) => { return true });
                prop.onSuccess(param);                
            } else {
                setResultMessage((value) => {return response.data.message});
            }
        })
        .catch((e) => {
            setResultMessage((value) => {return "パスワードの変更に失敗しました。"});
        })
    }

    const onCloseDialog = async (event: {}, reason: "backdropClick" | "escapeKeyDown") => {                
        prop.setIsOpen((value) => {return false});
        await wait(50);
        prop.onClose();
        reset();
        setResultFlg((value) => {return false});
        setResultMessage((value) => { return "" });        
    }

    return (
        <Dialog open={prop.isOpen} onClose={onCloseDialog}>
            <DialogTitle className={dialogcss['dialogTitle']}>パスワード変更</DialogTitle>
            <form onSubmit={(e) => { handleSubmit(onSubmit)(e) }}>
                <DialogContent className={dialogcss['dialogContents']}>
                    {
                        resultFlg ?
                        <div>
                            <div className={configcss['resultMessage']}>{resultMessage}</div>
                        </div>
                        :
                        <>
                    <div className={dialogcss['inputBox']}>
                        <div className={dialogcss['inputName']}>
                            <h3>現在のパスワード</h3>
                        </div>
                        <Controller
                            control={control}
                            name="currentPassword"
                            render={({ field }) => (
                                <input type="password" {...field} {...register('currentPassword')}></input>
                            )}
                        />                        
                    </div>
                    <div className={logincss['error']}>{errors.currentPassword?.message}</div>
                    <div className={dialogcss['inputBox']}>
                        <div className={dialogcss['inputName']}>
                            <h3>新規パスワード</h3>
                        </div>
                        <Controller
                            control={control}
                            name="newPassword"
                            render={({field}) => (
                                <input type="password" {...field} {...register('newPassword')}></input>
                            )}
                        />                        
                    </div>
                    <div className={logincss['error']}>{errors.newPassword?.message}</div>
                    <div className={dialogcss['inputBox']}>
                        <div className={dialogcss['inputName']}>
                            <h3>新規パスワード（確認用）</h3>
                        </div>
                        <Controller
                            control={control}
                            name="confirmationPassword"
                            render={({field}) => (
                                <input type="password" {...field} {...register('confirmationPassword')}></input>
                            )}
                        />                    
                    </div>
                    <div className={logincss['error']}>{errors.confirmationPassword?.message}</div>
                    <div className={logincss['error']}>{resultMessage}</div>
                    </>
                        }
                </DialogContent>
                <DialogActions>
                        <div className={dialogcss['footerBtnLayout']}>
                            {
                                isLoading ?
                                <CircularProgress></CircularProgress>
                                :
                                <>
                                {
                                    resultFlg ?
                                    null
                                    :
                                    <button type="submit" className={dialogcss['footerBtn']}>&nbsp;変更&nbsp;</button>
                                }
                                <button type="button" className={dialogcss['footerBtn']} onClick={async (e) => {await onCloseDialog({}, "escapeKeyDown")}}>閉じる</button>
                                </>
                            }
                        </div>
                </DialogActions>
            </form>
        </Dialog>
    )
}